/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelListItem64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelListItem64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.22"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 19H51V45H13V19ZM12 19C12 18.4477 12.4477 18 13 18H51C51.5523 18 52 18.4477 52 19V45C52 45.5523 51.5523 46 51 46H13C12.4477 46 12 45.5523 12 45V19ZM46 24H22V40H46V24ZM22 23C21.4477 23 21 23.4477 21 24V40C21 40.5523 21.4477 41 22 41H46C46.5523 41 47 40.5523 47 40V24C47 23.4477 46.5523 23 46 23H22ZM19 33C19 33.5523 18.5523 34 18 34C17.4477 34 17 33.5523 17 33C17 32.4477 17.4477 32 18 32C18.5523 32 19 32.4477 19 33Z"
            fill="currentColor"
          />
          <path
            d="M18 25C18.5523 25 19 24.5523 19 24C19 23.4477 18.5523 23 18 23C17.4477 23 17 23.4477 17 24C17 24.5523 17.4477 25 18 25Z"
            fill="currentColor"
          />
          <path
            d="M46 23.5H22C21.7239 23.5 21.5 23.7239 21.5 24V32C21.5 32.2761 21.7239 32.5 22 32.5H46C46.2761 32.5 46.5 32.2761 46.5 32V24C46.5 23.7239 46.2761 23.5 46 23.5Z"
            stroke="currentColor"
          />
          <rect
            opacity="0.1"
            x="22"
            y="24"
            width="24"
            height="8"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelListItem64Icon.tags = ['add', 'panel', 'list', 'menu', 'window'];

AddPanelListItem64Icon.category = '64x64 (Add panel)';

AddPanelListItem64Icon.iconSize = 64;
